/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { NewsCreate, NewsBare } from 'SharedDir/declarations/news';
import { ADMINISTRATION_NEWS, newsUrl } from 'SharedDir/backend/endpoints/administration-news';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { Paginated } from 'SharedDir/declarations/pagination';

export default class AdministrationNewsApiClass extends SimpleApi<NewsBare, NewsCreate> {
  constructor() {
    super(newsUrl);
  }

  public async publish<T>(id: number, params?: T) {
    const { data } = (await http({
      ...ADMINISTRATION_NEWS.PUBLISH(id),
      params,
    })) as AxiosResponse<Paginated<NewsBare, any>>;
    return data;
  }

  public async unpublish<T>(id: number, params?: T) {
    const { data } = (await http({
      ...ADMINISTRATION_NEWS.UNPUBLISH(id),
      params,
    })) as AxiosResponse<Paginated<NewsBare, any>>;
    return data;
  }
}
